var jstreeModule = require('../../../../../node_modules/jstree/dist/jstree.min.js'); // jstree library
var AjaxController = require('./../../services/AjaxController');

var ProfitAndLossController = function() {

    this.$jsTree = $('#js-profit-and-loss-create-expenditure-jstree');
	this.$categories = $('#js-profit-and-loss-create-expenditure-jstree li[data-type="category"]');
	// this.arrayCategories = [];
	this.$generateBtn = $('#profit-and-loss-generate');
	this.$exportBtn = $('#profit-and-loss-export');
	this.$exportForm = $('#export');
	this.$dateFromField = $('#date_from');
	this.$dateToField = $('#date_to');
	this.$results = $('#results');
	this.$selectAll = $('#js-profit-and-loss-select-all');

	this.$fieldTotalRevenue = $('#results-total-revenue');
	this.$fieldCostOfGoodsSold = $('#results-cost-of-goods-sold');
	this.$fieldGrossProfit = $('#results-gross-profit');
	this.$fieldTotalExpenditure = $('#results-total-expenditure');
	this.$fieldNetProfit = $('#results-net-profit');

	this.$fieldTrExpenditure = $('#tr-expenditure');
	this.$fieldTrAfterExpenditure = $('#tr-after-expenditure');

	this.statisticsTotalRevenue = 0;
	this.statisticsCostOfGoodsSold = 0;
	this.statisticsGrossProfit = 0;
	this.statisticsExpenditures = [];
	this.statisticsTotalExpenditure = 0;
	this.statisticsNetProfit = 0;

    var self = this; // Needed for using all constructor variables inside this function, note the difference -> no "this" but "var" at the beginning

    (function()
    {
	    self.$jsTree.jstree({
		    "plugins" : [ "wholerow", "checkbox" ]
	    });

	    // self.$categories.each(function() {
		 //    self.arrayCategories.push($(this).attr('id'))
	    // });

	    // self.$jsTree.jstree("disable_checkbox", self.arrayCategories);

	    self.$generateBtn.click(function(e){
		    self.generateReport(e);
	    });

	    self.$exportForm.submit(function(e){
		    self.export(self, this, e);
	    });

	    self.$selectAll.click(function(e){
	    	e.preventDefault();
		    self.$jsTree.jstree("select_all")
	    });

    }());

}

ProfitAndLossController.prototype.export = function(self, form, e){

	// e.preventDefault();

	var object = {
		'dateFrom' : self.$dateFromField.val(),
		'dateTo' : self.$dateToField.val(),
		'totalRevenue' : self.statisticsTotalRevenue,
		'costOfGoodsSold' : self.statisticsCostOfGoodsSold,
		'grossProfit' : self.statisticsGrossProfit,
		'expenditures' : self.statisticsExpenditures,
		'totalExpenditure' : self.statisticsTotalExpenditure,
		'netProfit' : self.statisticsNetProfit
	}

	$('<input />').attr('name', 'data').attr('value', JSON.stringify(object)).addClass('none').appendTo(form);
}

ProfitAndLossController.prototype.generateReport = function(e) {
	e.preventDefault();

	var self = this;
	var selectedElmsIds = this.$jsTree.jstree("get_selected"),
			dateFrom = this.$dateFromField.val(),
			dateTo = this.$dateToField.val();

	/** Prepare and run AJAX*/
	var url = '/api/finances/generate-profit-and-loss';
	var data = { dateFrom : dateFrom, dateTo: dateTo, selectedExpenditureTypes : selectedElmsIds };

	var success = function (response) {
		console.log('Success');

		self.statisticsTotalRevenue = parseFloat(response.totalRevenue).toFixed(2);
		self.statisticsCostOfGoodsSold = parseFloat(response.costOfGoodsSold).toFixed(2);
		self.statisticsGrossProfit = (self.statisticsTotalRevenue - self.statisticsCostOfGoodsSold).toFixed(2);
		self.statisticsExpenditures = response.expenditureTypes;
		self.statisticsTotalExpenditure = parseFloat(response.totalExpenditure).toFixed(2);
		self.statisticsNetProfit =  (self.statisticsGrossProfit - self.statisticsTotalExpenditure).toFixed(2);

		self.$fieldTotalRevenue.html('&pound;' + self.statisticsTotalRevenue);
		self.$fieldCostOfGoodsSold.html('&pound;' + self.statisticsCostOfGoodsSold);
		self.$fieldGrossProfit.html('&pound;' + self.statisticsGrossProfit);
		self.$fieldTotalExpenditure.html('&pound;' + self.statisticsTotalExpenditure);
		self.$fieldNetProfit.html('&pound;' + self.statisticsNetProfit);

		$('.expenditure-type').remove();

		$.map(self.statisticsExpenditures, function(value, index) {
			var code = '<tr class="expenditure-type">' +
					'<td>' + value.name + '</td>' +
					'<td></td>' +
					'<td class="col-subtract">&pound;' + parseFloat(value.amount_paid).toFixed(2) + '</td>' +
					'</tr>';

			self.$fieldTrAfterExpenditure.before(code);

		});

		self.$results.show();
		self.$exportForm.show();

	}

	var error = function (response) {
		console.log('Error');
		// console.log(response);
	}

	/** Send AJAX request */
	AjaxController.prototype.send(url, data, success, error);
}

module.exports = ProfitAndLossController;
